import generalApi from '@/api/generalApi.js'
import sanitizeTitle from '@/modules/blogs/helpers/slug.js'


export const setBlogs = async ({ commit }) => {
    const blogs = await generalApi.get('/v1/blogs/listado')
    commit('mutBlogs', blogs.data)
    //console.log('blogs', blogs.data)
    return blogs
}


export const selectBlog = async ({ commit }, b) => {
    commit('selectBlog', b)
}

export const updateBlog = async ({ commit }, blog) => {

    //console.log(blog)
    //return 'hola'
    try {
        const { id, carrera_id, tipo, slug, nombre, descripcion, content, bloquear } = blog[0]
        const select = blog[1]
        const dataToSave = { id, carrera_id, tipo, slug, nombre, descripcion, content, bloquear, select }
        const resp = await generalApi.put(`/v1/blogs/${id}`, dataToSave)
        return resp.data
    } catch (error) {
        return error.response.data
    }

}
export const createBlog = async ({ commit }, blog) => {

    
    try {
        const { id, carrera_id, tipo, slug, nombre, descripcion, content, bloquear } = blog[0]
        const select = blog[1]
        const dataToSave = { id, carrera_id, tipo, slug, nombre, descripcion, content, bloquear, select }

        const resp = await generalApi.post(`/v1/blogs/register`, dataToSave)
        commit('addBlog', resp.data.blog)
        return resp.data

    } catch (error) {
        return error.response.data
    }
}
export const deleteBlog = async ({ commit }, id) => {
    const del = await generalApi.delete(`/v1/blogs/${id}`)
    if (del.data.error) {
        return del.data
    } else {
        commit('deleteBlog', id)
        return id
    }
}
export const delImg = async ({ commit }, id) => {
    const del = await generalApi.get(`/v1/blogs/delimagen/${id}`)
    if (del.data.error) {
        return del.data
    } else {
        localStorage.setItem('blog', JSON.stringify(del.data.blog))
        //commit('deleteBlogImagen', id)
        return del.data
    }
}


